<template>
  <div class="info-detail-root">
    <el-form ref="refForm" :model="formData">
      <div class="v-grid-list">
        <div class="block-item" v-for="(bigItem, bigIndex) in formData.gridList
          ? formData.gridList
          : []" :key="bigIndex">
          <!-- 标题层 -->
          <div class="top-title">
            <div class="full-title">
              <div class="big-title">
                <span class="weight" v-show="bigItem.isMust">*</span>
                <span class="txt">{{ bigItem.title }}</span>
              </div>
            </div>
          </div>

          <div class="content-layout">
            <el-form-item :prop="'gridList.' + bigIndex + '.imageUrlList'" :rules="[
              {
                required: bigItem.isMust,
                message: '请上传至少一张图片',
                trigger: 'blur',
              },
            ]">
              <!-- 图片层 -->
              <div class="pic-layout">
                <div class="item" v-for="(item, index) in bigItem.imageUrlList
                  ? bigItem.imageUrlList
                  : []" :key="index">
                  <el-image :ref="`myImgB${bigIndex}S${index}`" :src="item" fit="cover" class="icon"
                    :initial-index="index" :preview-src-list="bigItem.imageUrlList" />
                  <div class="preview">
                    <el-image @click="clickImg(item, bigIndex)" :src="SeeIcon" class="btn-icon" />
                    <el-image v-if="!disabled" @click="handleDeleteImage(bigIndex, index)" :src="DelIcon"
                      class="btn-icon" />
                  </div>
                </div>
                <div class="item add-pic" v-if="!hideAddPicBtn(bigItem)" @click="handleUpload(bigIndex)">
                  <div class="image-wrap">
                    <el-image :src="AddIcon" />
                  </div>
                  <span class="text">上传照片</span>
                </div>
              </div>
            </el-form-item>
            <!-- 动态Filed -->
            <div class="input-layout">
              <div :class="{
                'input-item': true,
                'fill-wrap':
                  bigItem.filedList.length % 2 !== 0 &&
                  subIndex === bigItem.filedList.length - 1,
              }" v-for="(subItem, subIndex) in bigItem.filedList" :key="subIndex">
                <el-form-item :prop="'gridList.' +
                  bigIndex +
                  '.filedList.' +
                  subIndex +
                  '.modeValue'
                  " :rules="[
    {
      required: subItem.isMust,
      message: '值不能为空',
      trigger: 'blur',
    },
  ]">
                  <DynamicFiled :type="subItem.type" :disabled="disabled" v-model="subItem.modeValue"
                    :data-item="subItem" />
                </el-form-item>
              </div>
              <div>
                <el-form-item label="有效期：">
                  <!-- <el-date-picker
                        v-model="bigItem.periodValidity"
                        :disabled="type == 'view'"
                        type="daterange"
                        size="mini"
                        style="margin-top: 10px; width: 100%"
                        range-separator="-"
                        start-placeholder="开始日期"
                        end-placeholder="结束日期"
                        value-format="yyyy-MM-dd"
                      >
                      </el-date-picker> -->
                  <el-date-picker :disabled="type == 'view'" v-model="bigItem.periodValidity[1]" type="date"
                    placeholder="有效期至" :clearable="false" @change="(value) => {
                      changeDate(value, bigIndex);
                    }">
                  </el-date-picker>
                </el-form-item>
                <el-form-item>
                  <el-radio-group v-model="bigItem.termType" style="margin-top: 10px" :disabled="type == 'view'" @change="(value) => {
                    changePeriod(value, bigIndex);
                  }
                    ">
                    <el-radio :label="2">本年底</el-radio>
                    <!-- <el-radio :label="3">3年</el-radio>
                        <el-radio :label="4">4年</el-radio>
                        <el-radio :label="5">5年</el-radio>
                        <el-radio :label="6">10年</el-radio> -->
                    <el-radio :label="1">长期</el-radio>
                  </el-radio-group>
                </el-form-item>
              </div>
            </div>
          </div>

          <div class="check-item">
            <el-form-item label="检查细项">
              <el-radio-group v-model="bigItem.qualifiedSelect" style="margin-top: 13px"
                :disabled="pageType == 'record' ? true : false" @change="choseCheckStatus(bigItem)">
                <el-radio :label="0">待检查</el-radio>
                <el-radio :label="1">合格</el-radio>
                <el-radio :label="2">不合格</el-radio>
              </el-radio-group>
            </el-form-item>
          </div>
        </div>

        <div class="empty-div">
          <el-empty v-if="formData.gridList.length == 0" style="height:100%" description="暂无数据" />
        </div>

      </div>
    </el-form>

    <UploadImageView ref="imgupload" request-id="1" :imgType="imgType" />

    <div style="width: 34%;
    height: 100%;
    position: fixed;overflow: hidden;
    left: 0;
    top: 0px;
    z-index: 1031;" id="jinbiao" ref="jinbiao" @mouseenter="zoomEnable = true" @mouseleave="zoomEnable = false"
      v-if="dialogDiv">
      <div id="mouseenterDiv" v-if="dialogDiv" @mouseenter="mouseenter"
        style="width: 10px;cursor:move;position: absolute;right: 0px;top: 0px;height: 100%;z-index: 2500;"></div>
      <imageViewer v-if="showViewer" id="imageViewer" style="overflow: hidden;box-shadow: 2px #fafafa;"
        :initialIndex="initialIndex" :zoomEnable="zoomEnable" ref="imageViewer" :append-to-body="false"
        :on-close="closeViewer" :onSwitch="onSwitch" :url-list="src" />
    </div>


  </div>
</template>

<script>
import imageViewer from './imageViewer.vue'
import dayjs from "dayjs";
import DynamicFiled from "../components/dynamicFiled.vue";
//该组件是复制 @/views/merchantsettlement/myupload.vue，因为这里的代码会被复制到 大商场共同使用
import UploadImageView from "../components/UploadImage.vue";
import Croper from "@/components/cropper"
import _ from "lodash";
const IConst_See_Icon = require("@/assets/zz/see-icon.png");
const IConst_Del_Icon = require("@/assets/zz/del-icon.png");
const IConst_Add_Icon = require("@/assets/zz/add-icon.png");

import {
  getCertifyDetail,
  doTmpSaveCertify,
  doCommitCertify,
} from "@/api/myQualification/index";

import { viewHelp, IConst_State } from "../util/ViewHelp";

export default {
  components: { DynamicFiled, UploadImageView, imageViewer, Croper },
  props: {
    disabled: {
      type: Boolean,
      default: () => false,
    },
    pageType: {
      type: String,
      default: 'check'
    },
    type: {
      default: "view",
    },
    infoDetailData: {
      type: Array,
      default: () => [],
    },
    queryScopeListData: {
      type: Array,
      default: () => [],
    },
  },
  watch: {
    infoDetailData: {
      immediate: true,
      handler: function (val) {
        if (val) {
          this.transServiceDataToFormData(val);
        }
      },
    },

  },
  data() {
    return {
      src: [],
      initialIndex: 0,
      dialogDiv: false,
      showViewer: false,
      zoomEnable: false,
      //图片预览 
      IConst_State: IConst_State,
      SeeIcon: IConst_See_Icon,
      DelIcon: IConst_Del_Icon,
      AddIcon: IConst_Add_Icon,
      showImageViewer: false,
      previewUrls: null,
      imgType: "",
      IConst_Max_Pic_Count: 5,
      rangeList: [],
      formData: {
        //底部的动态域字段
        filedList: [

        ],
        gridList: [],
        // 经营范围
        checkList: [],
      },
      currentBigIndex: -1, //当前资质图片 gridList索引
      cropDialogVisible: false,
      cropUrl: '',
    };
  },
  computed: {
    status() {
      const status = this.$store.state.qualification?.detail
        ? this.$store.state.qualification.detail.status
        : "";
      return status;
    },
    showDraftBtn() {
      return this.status === this.IConst_State.None || this.status === "";
    },
  },
  created() {

  },
  mounted() {

  },
  methods: {
    closeDialog() {
      this.cropUrl = ''
      this.cropDialogVisible = false
    },

    // 关闭图片弹窗
    closeViewer() {
      this.showViewer = false
      this.dialogDiv = false
    },
    editView() {

      this.cropUrl = this.src[this.initialIndex]
      this.cropDialogVisible = true

    },
    onSwitch(index) {
      this.initialIndex = index
    },
    // 点击图片
    clickImg(li, index) {
      this.showViewer = false
      this.dialogDiv = false
      this.dialogDiv = true
      this.initialIndex = this.src.findIndex(item => {
        return item == li
      })
      this.$nextTick(() => {
        const v = document.getElementById('jinbiao');
        v.style.setProperty('width', '34%', 'important')
        this.showViewer = true
        this.$nextTick(() => {
          const c = document.getElementById('imageViewer');
          c.style.setProperty('width', '34%')
        })
      })
    },
    // 鼠标进入
    mouseenter() {
      const v = document.getElementById('jinbiao');
      const c = document.getElementById('imageViewer');
      const mouseenterDiv = document.getElementById('mouseenterDiv');
      mouseenterDiv.onmousedown = function (e) {
        document.onmousemove = function (e) {
          v.style.setProperty('width', e.x + 'px', 'important')
          c.style.setProperty('width', e.x + 'px', 'important')
        }
        // 鼠标松开事件
        document.onmouseup = function (evt) {
          document.onmousemove = null;
          document.onmouseup = null;
          // v.releaseCapture && v.releaseCapture();
        }
        // v.setCapture && v.setCapture();
      }
    },
    changeDate(value, index) {
      if (!value) {
        return
      }
      // this.formData.gridList[index].termType = ''
      this.formData.gridList[index].periodValidity[0] =
        dayjs().format("YYYY-MM-DD");
      this.formData.gridList[index].periodValidity[1] = dayjs(value).format("YYYY-MM-DD");
    },
    changePeriod(value, index) {
      if (value == 1) {
        this.formData.gridList[index].periodValidity[0] =
          dayjs().format("YYYY-MM-DD");
        this.formData.gridList[index].periodValidity[1] = dayjs()
          .add(999, "year")
          .format("YYYY-MM-DD");
        // this.formData.gridList[index].endValidDate = dayjs().add(999, "year").format("YYYY-MM-DD")
      }
      if (value == 2) {
        this.formData.gridList[index].periodValidity[0] =
          dayjs().format("YYYY-MM-DD");
        this.formData.gridList[index].periodValidity[1] =
          dayjs().format("YYYY-12-31");
        // this.formData.gridList[index].endValidDate = dayjs().format("YYYY-12-31");
      }

      this.formData = JSON.parse(JSON.stringify(this.formData));
    },
    handleDownTemplate(fileUrl) {
      window.open(fileUrl);
    },


    hideAddPicBtn(bigItem) {
      return (
        this.disabled ||
        (bigItem.imageUrlList &&
          bigItem.imageUrlList instanceof Array &&
          bigItem.imageUrlList.length >= this.IConst_Max_Pic_Count)
      );
    },
    getFormData() {
      let validForm = false;
      this.$refs.refForm.validate((valid, fields) => {
        validForm = valid;
      });
      if (validForm) {
        return this.formData;
      }
    },


    transServiceDataToFormData(val) {
      let certifyList = val;
      if (certifyList && certifyList.length > 0) {
        let certifyListArr = certifyList.map((cert) => {
          return {
            ...cert,
            termType: Number(cert.termType),
            title: cert.certificateName,
            isMust: Boolean(cert.required),
            imageUrlList: cert.certificateImages || [],
            example: cert.example,
            template: cert.template,
            periodValidity: [cert.startValidDate, cert.endValidDate || ""],
            filedList:
              cert.fields &&
              cert.fields.map((item) => {
                return {
                  ...item,
                  type: item.inputType,
                  tip: item.fieldNameText,
                  modeValue: item.fieldValue,
                  isMust: item.required || false,
                  certificateId: item.certificateId,
                  options: this.transSelectEnumToOptions(item.selectEnum),
                };
              }),
          };
        });

        this.formData.gridList = certifyListArr;
        console.log(this.formData.gridList, '--this.formData.gridList ')
        this.formData.gridList.forEach(item => {
          let imgs = []
          if (item.imageUrlList.length > 0) {
            item.imageUrlList.forEach(el => {
              imgs.push(el)
            })
          }
          this.src = this.src.concat(imgs)
        })

        console.log(this.formData.gridList, '---- this.formData.gridList')
      }
    },

    transSelectEnumToOptions(selectEnum) {
      let options = [];
      if (selectEnum) {
        try {
          const objValue = JSON.parse(selectEnum);
          Object.keys(objValue).forEach((key) => {
            options.push({
              label: objValue[key],
              value: key,
            });
          });
        } catch (error) { }
      }
      return options;
    },

    // 选择检查状态
    choseCheckStatus(e) {
      const {
        type,
        shopId,
      } = this.$route.query;
      e.shopId = shopId
      console.log(e)
      this.$emit('saveTemporaryCheck', e)
    }

  },
};
</script>

<style scoped lang="scss">
.info-detail-root {
  width: 100%;
  margin: 0 0px;
  --border-line-color: #d9d9d9;

  display: flex;
  flex-direction: column;
}

.v-grid-list {
  padding-bottom: 8px;
  box-sizing: border-box;
  // border-bottom: 1px solid var(--border-line-color);
  // display: grid;
  // grid-template-columns: repeat(2, 1fr);

  // column-count: 2;
  // column-width: 494px; /* 每列每个元素最小的宽度 */
  // column-gap: 24px; /* 每列的距离，不设置这个可以通过margin来设置边距 */

  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
}

/**瀑布块 */
.block-item {
  display: block;
  --btn-focus-color: #cf1422;

  flex-shrink: 0;
  width: calc(50% - 10px); //固定宽度
  background: #ffffff;
  border: 1px solid var(--border-line-color);
  border-radius: 4px;

  margin-bottom: 24px;
  margin-right: 0;
  position: relative;
  left: 0;
  //padding-bottom: 40px;


  .top-title {
    display: flex;
    flex-direction: column;
    padding: 12px 16px 12px 8px;
    border-bottom: 1px solid var(--border-line-color);

    .full-title {
      display: flex;
      align-items: center;

      box-sizing: border-box;
      justify-content: space-between;

      .big-title {
        display: flex;
        align-items: center;

        .weight {
          width: 8px;
          height: 22px;
          font-size: 14px;
          font-weight: 400;
          color: #f6212d;
          line-height: 22px;
          position: relative;
          top: 2px;
        }

        .txt {
          font-size: 14px;
          font-weight: 700;
          color: #262626;
        }
      }
    }

    .btn-layout {
      .el-button--text {
        color: var(--btn-focus-color);
      }

      ::v-deep .el-button {
        padding: 0;

        +.el-button {
          margin-left: 16px;
        }
      }
    }

    .remarks {
      padding-left: 8px;
      box-sizing: border-box;
      font-size: 14px;
      font-weight: 400;
      color: #8c8c8c;
      margin-top: 4px;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }
  }

  .content-layout {
    padding: 0;
    box-sizing: border-box;
    display: flex;
    border-bottom: 1px solid var(--border-line-color);
    width: 100%;
    height: calc(100% - 80px);

    ::v-deep .el-form-item {
      flex: 1;

      .el-form-item__content {
        width: 100%;
      }
    }

    .pic-layout {
      display: flex;
      width: 100%;
      padding: 16px;

      .item {
        width: 86px;
        height: 86px;
        background: #ffffff;
        border: 1px solid #d9d9d9;
        border-radius: 4px;
        position: relative;
        overflow: hidden;

        &+.item {
          margin-left: 8px;
        }

        .icon {
          position: relative;
          width: 100%;
          height: 100%;
        }

        .preview {
          position: absolute;
          visibility: hidden;
          left: 0;
          top: 0;
          width: 100%;
          height: 100%;
          opacity: 0.5;
          background: #000000;
          display: flex;
          align-items: center;
          justify-content: center;

          .btn-icon {
            width: 16px;
            height: 16px;
            cursor: pointer;

            &+.btn-icon {
              margin-left: 8px;
            }
          }
        }

        &:hover {
          .preview {
            visibility: visible;
          }
        }

        &.add-pic {
          border: 1px dashed #d9d9d9;
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          cursor: pointer;

          .image-wrap {
            border: 1px dashed #d9d9d9;
            width: 20px;
            height: 20px;

            &>* {
              width: 100%;
              height: 100%;
            }
          }

          .text {
            font-size: 14px;
            font-weight: 400;
            color: #595959;
            margin-top: 8px;
          }
        }
      }
    }

    .input-layout {
      display: flex;
      flex-wrap: wrap;
      padding-top: 8px;
      box-sizing: border-box;
      width: 60%;
      flex-shrink: 0;
      padding: 16px;
      position: relative;

      &::after {
        content: "";
        position: absolute;
        top: 0;
        left: 0;
        width: 1px;
        height: 100%;
        background: var(--border-line-color);
      }

      .input-item {
        margin-top: 8px;
        width: 100%;

        // &:nth-child(2n) {
        //   margin-left: 8px;
        // }

        &.fill-wrap {
          width: 100%;
        }
      }
    }
  }
}

/**底部动态域 */
.bottom-dynamic-filed {
  display: flex;
  flex-wrap: wrap;
  padding-top: 24px;
  padding-bottom: 32px;
  box-sizing: border-box;
  border-bottom: 1px solid var(--border-line-color);

  .input-layout {
    display: flex;
    flex-wrap: wrap;
    width: 100%;

    box-sizing: border-box;

    .input-item {
      margin-top: 8px;
      width: calc(33.33333% - 6px);

      &:nth-child(3n + 2),
      &:nth-child(3n) {
        margin-left: 8px;
      }

      &.fill-wrap {
        width: 100%;
      }
    }
  }
}

/**按钮层 */
.bottom-btn-layout {
  display: flex;
  justify-content: center;
  margin-top: 32px;

  ::v-deep .el-button {
    width: 120px;

    &+.el-button {
      margin-left: 12px;
    }
  }

  ::v-deep .el-button--danger {
    background-color: #f5222d;
    border-color: #f5222d;

    &:hover {
      background: #f78989;
      border-color: #f78989;
    }
  }
}

/**el-form */
.el-form {
  .el-form-item {
    margin: 0 !important;
    padding: 0;
    box-sizing: border-box;
  }
}

::v-deep .el-form-item__content {
  line-height: inherit;

  .el-form-item__error {
    padding-top: 0px;
  }
}

.check-item {
  height: 40px;
  padding-left: 10px;
  // position: absolute;
  bottom: 0;
  width: 100%;
  //flex: 1;
}

.empty-div {
  width: 100%;
  margin-top: 20vh;
}
</style>
